/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import RichTextEditor from 'Components/UI/RichTextEditor';
import RichTextEditorCustomContextMenu from 'Components/UI/RichTextEditorCustomContextMenu';
import RichTextDisplayOverride from 'Components/UI/Overrides/RichTextDisplay';
import RichTextWithHelper
  from 'Components/UI/RichTextEditor/RichTextWithHelper';

export const ClientExperienceNoteOverride = fr.metaOverride()
  .overrideAll({ hidden: true })
  .nameOverride('content', {
    hidden: false,
    _component: () => RichTextWithHelper,
  });

export const MissionControlNoteOverride = fr.metaOverride()
  .overrideAll({ hidden: true })
  .nameOverride('content', {
    hidden: false,
    _component: () => RichTextEditor,
    _customProps: {
      size: 'xl',
    },
  });

export const MissionControlNoteOverrideContextMenu = fr.metaOverride()
  .overrideAll({ hidden: true })
  .nameOverride('content', {
    hidden: false,
    _component: () => RichTextEditorCustomContextMenu,
    _customProps: {
      size: 'md',
    },
  });

export const TimelineNoteOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride('noteType', { ordinal: 1 })
  .nameOverride('content', {
    hidden: false,
    _component: () => RichTextEditor,
    _customProps: {
      size: 'md',
    },
    ordinal: 2,
  });

export const noteHistoryTitleGenerator = () => () => 'Note';

export const NoteHistoryOverride = fr.metaOverride()
    .override({ readonly: true }, { hidden: true })
    .nameOverride('noteType', { ordinal: 1, hidden: false })
    .nameOverride('content', {
        ordinal: 2,
        hidden: false,
        // although it's technically readonly, setting readonly to true causes the component override to be ignored
        readonly: false,
        _component: () => RichTextDisplayOverride,
    })
    .nameOverride('updatedAt', { _titleGenerator: noteHistoryTitleGenerator });
